import React from "react";
import axios, {AxiosRequestConfig, AxiosResponse} from "axios";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";
import {SET_SNACKBAR} from "../constants";
import {setSnackbar} from "../../../util/state/globalAction";
import {snackbarTypes} from "../../../util/state/globalVariables";

export const useApi = () => {

    const {dispatchGlobalData} = React.useContext(GlobalContext);

    const setEventListenerLoading = (value: boolean) => {
        window.dispatchEvent(new CustomEvent("LOADING", {detail: value}));
    };

    async function GET(url: string, config?: AxiosRequestConfig<any>, loading = false) {
        if (!loading) {
            setEventListenerLoading(true);
        }
        return axios.get<AxiosResponse>(url, config).then(onSuccess).catch(onError);
    }

    function POST(url: string, payload?: any, config?: AxiosRequestConfig<any>, loading = false) {
        if (!loading) {
            setEventListenerLoading(true);
        }
        return axios.post<AxiosResponse>(url, payload, config).then(onSuccess).catch(onError);
    }

    function PUT(url: string, payload?: any, config?: AxiosRequestConfig<any>, loading = false) {
        if (!loading) {
            setEventListenerLoading(true);
        }
        return axios.put<AxiosResponse>(url, payload, config).then(onSuccess).catch(onError);
    }

    function PATCH(url: string, payload?: any, config?: AxiosRequestConfig<any>, loading = false) {
        if (!loading) {
            setEventListenerLoading(true);
        }
        return axios.patch<AxiosResponse>(url, payload, config).then(onSuccess).catch(onError);
    }

    function DELETE(url: string, config?: AxiosRequestConfig<any>, loading = false) {
        if (!loading) {
            setEventListenerLoading(true);
        }
        return axios.delete<AxiosResponse>(url, config).then(onSuccess).catch(onError);
    }

    const onSuccess = function (response: any) {
        setEventListenerLoading(false);
        if (response.data.errorCode === 207) {
            if (response.data.reportedErrors?.length > 0) {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: response.data.reportedErrors.map((err: string) => err).join("\n"),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true
                        }
                    }
                });
            } else {
                dispatchGlobalData(SET_SNACKBAR.ERROR);
            }
        }

        return response.data;
    };

    const onError = function (error: any) {
        setEventListenerLoading(false);
        if (axios.isCancel(error)) {
            return Promise.reject();
        }
        let reportedErrors;
        if (error.response?.data?.errorDetails) {
            reportedErrors = JSON.parse(error.response?.data?.errorDetails).reportedErrors;
        }
        if (reportedErrors?.length > 0) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: reportedErrors.map((err: string) => err).join("\n"),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true
                    }
                }
            });
        } else {
            dispatchGlobalData(SET_SNACKBAR.ERROR);
        }
        return Promise.reject(error);
    };


    return {GET, POST, PUT, PATCH, DELETE};
};
